var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownquestion5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 334.1 394.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-4 {\n        stroke: #747475;\n      }\n\n      .cls-1, .cls-6 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #4c4c4c;\n      }\n\n      .cls-2, .cls-6 {\n        stroke: #4c4b4c;\n      }\n\n      .cls-3 {\n        fill: #e9e9e9;\n        stroke: #e9e9e9;\n      }\n\n      .cls-4 {\n        fill: #757575;\n      }\n\n      .cls-5 {\n        fill: #bbb;\n        stroke: #bbb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clothes_Colour",
    "data-name": "Clothes Colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M301.6,280.7c-9.5-20-24.4-44.8-29.5-48.5s-18.3-8.9-18.3-8.9c0,0,14.5-12.7,16.7-19.1,4.3-12.5-9.2-34.7-9.9-40-2.3-16.9-50-62.6-54.7-68.2-2.7-3.2-55.7-48.2-55.7-48.2,0,0-55.7-11.5-61-8.9-4.9,2.4-35.1,18.9-38.9,21.6-4,2.9-19.2,24.6-20.8,29.3s-3.7,36.2-1.5,49.9,29.3,46.6,29.3,46.6c-.8,5.3-5,22.4-2.7,34,1.3,6.6,11.9,9.4,11.9,9.4,0,0-1-1.2-6.2,2.5-5.2,3.7-20,28.4-29.5,48.5s-23.8,52-29.5,58.7l163.8,13.2,1-44.5,1,44.5,163.8-13.2c-5.8-6.7-20-38.6-29.5-58.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.7,69.1c-12.6-5.1-54.2,13.5-60.8,15.4s-8.4,4.6-8.5,11.6c-.2,9.2,5.8,46.8,5.8,46.8.7,14.2,6.4,14.4,14.3,32.4l16.7,21.9c19.3,16.4,42.8,44.5,47.9,53.5,4.3,7.5,20.7,46.5,20.7,46.5h7s15.2-39.8,20.7-46.5,43.1-71.4,43.1-71.4c.8-12.1-4.6-18.6-8.9-27.4l-10.6-16.5c-20.2-17.7-43-36.5-49.9-48.7,0,0-29.3-14.1-37.6-17.4h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.3,350.9s20.1-44.8,24-55.7c4.2-11.8,3.6-24,3.6-24,0,0,5.9,18.8,5.9,31.6v57.8l-33.5-9.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.5,251.6c-.2-.3-.6,0-.4.3,7.4,11.8,26.2,42.9,26.2,52.1s11.4,64.4,11.4,64.4l23.6-13.5-1.6-35.7-46-50.7-13.2-17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.4,283l-5.7,69.6s14.4-50,18-56.6,23.2-49.6,26.9-48.7,26.6,13.7,26.9,17.4,38.9,79.6,38.9,93.7l28.2-12.8-37.9-78.1s-20.9-35.8-23.8-36-14.2-6-14.2-6c0,0-27.4,20.8-31.8,27.9-4.4,7.1-25.6,29.5-25.6,29.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.2,348.5c.4-13.6,7-84.9,7-84.9,0,0,11.8,11.2,13.3,24.3,1.1,9.6,10,64.8,10,64.8l-30.2-4.1h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Colour",
    "data-name": "Mask Colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.7,158.1s10,2.2,14,4.7,13.5,11.5,22,12.9c8.5,1.4,61.9-.9,66.4-7.8s-11.6-49.7-14.8-56.1-57.2-33.4-57.2-33.4l-27.4,14.2s.4,6.9-2.6,10.2c-2.9,3.3-9.7,10.3-9.7,10.3,0,0-5.2,24.8-1,31.6,4.2,6.8,10.4,13.4,10.4,13.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.3,142.8s-1.5-22.7,5-33.8c-2,2-5.6,2.5-8.9,3.4l3.9,30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.8,74.8s-20.6,8.6-27.7,19.3c.9-2.7-.8-6.1-1.3-9.5l29-9.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.9,86s14.7-7.3,23.6-4c9.5,3.5,21.2,16.6,21.2,16.6l-2.2,3.5s15.9,2.8,22.9,8.9,26,32.1,30.4,40c0,0-14.7-40.3-19.6-45.4-4.8-5.1-15.5-14.8-23.9-18.3-8.4-3.5-10.8-10.6-10.8-10.6,0,0-21.8-2.8-25.9-.2s-15.7,9.5-15.7,9.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M145.8,144.7s0-11.1-1.7-12-18.7-4.5-26.2-11.9c-7.6-7.5-6.9-11.8-6.5-12.9s3.1-6.9,3.1-6.9c0,0,3.2,14.7,6.8,17.4s22.4,9.3,29,10.3l-3,13.7-1.4,2.3h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Lines",
    "data-name": "Mask Lines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.6,102.4c6.4-10.3.9-18.2.9-18.2,0,0,10.7-6.3,22-8.9,15.4-3.4,29.3,1,29.3,1,0,0,2.6,5.9,10.8,11.1,8.2,5.1,18.8,6.4,27.3,24.3,8.4,18,20.9,46.7,15,56.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.1,145.6s-.6-1.8.1-4.7,1.6-5.7,1.6-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.9,138.5s-6.9,9.8-9.2,13.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M165.6,153.1s-1.4.4-2.6,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.1,89.1c-7,7.7-10.6,14-11,16.4-1.1,6.3,1.3,11.7,1.3,11.7,0,0,6.7-6.6,8.9-12.7,2.2-6.1.8-15.4.8-15.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M146.6,100c-2.7-.5-3.6-6-8.2-7.7-2.8-1-6.6,1.6-6.6,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.2,89.9s-.4-3.7-2-6c-3.2-4.3-6.7,1.3-9.1-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.9,97.6c4.9,1.2,3.9,11.3-6.8,8.5-7.6-1.9-6-10.7-12.7-6.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.9,102c-6.4,10.3-16,8.8-16,8.8,0,0-1,12.3,1.7,23.7,3.7,15.4,13.7,25.9,13.7,25.9,0,0,6.5-.3,14.7,4.8,8.2,5.1,14,14.1,33.8,13.9s51.2-1.7,57.1-11.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.1,145.6s-1.8.2-4.1,2.2-4.4,4-4.4,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149,165.6s5.8-10.4,8.1-14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.9,158.9s-.3-1.4,1-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.8,156.8c3.8-9.6,7.9-15.6,9.9-17.1,5.2-3.8,11.1-3.9,11.1-3.9,0,0-3,8.9-7.5,13.5s-13.5,7.4-13.5,7.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.9,165.1c-1.7-2.2-7-.6-10.5-4-2.2-2.1-1.5-6.7-1.5-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.5,156.6s-3.5,1.3-6.2.8c-5.3-.9-1.8-6.6-8.3-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.1,170.9c3.3,3.9,11.9-1.4,4.7-9.9-5.1-5.9-12.2-.7-11.7-8.4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clothes_Lines",
    "data-name": "Clothes Lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,309.1l13.5-33.2s-3.4-18.7-4.1-23.2-6.7-9.8-6.7-9.8c0-.7,1.5-1.1,1.5-1.8,1-4,2.3-6.1,3.9-8.6,3.8-2.8,4.7-4.1,4.7-4.1,0,0-1.6-3.7-4.4-5.8,0,0-1.6,2.9-4.5,3.6h-4.1c0,.1-4.1,0-4.1,0-2.9-.8-4.5-3.6-4.5-3.6-2.8,2.1-4.4,5.8-4.4,5.8,0,0,.9,1.3,4.7,4.1,1.6,2.5,2.9,4.6,3.9,8.6,0,.6,1.6,1.1,1.5,1.8,0,0-5.9,5.3-6.7,9.8-.8,4.5-4.1,23.2-4.1,23.2l13.5,33.2v.5-.2c.1,0,.2.2.2.2v-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.3,245.9s-3,6.1-2.2,7.4,2.2,1.8,2.2,1.8c0,0,1.5-.5,2.2-1.8s-2.2-7.4-2.2-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157.7,244s5.1-1.9,8.6-1.9,8.8,1.9,8.8,1.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.1,210.5s-5.6-1.1-8.2-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.3,245.9s3,6.1,2.2,7.4-2.2,1.8-2.2,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257.6,223.3s6.1,2.4,12.9,6.4c19.8,11.7,52.2,98,60.6,108.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.3,217.8s14.6,0,25.2-20.8c0,0,13.2,8.6,14.5,9.5,0,0-8.6,31.7-15.6,37.1,0,0-14.5-25.6-24.1-25.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.8,213.4s23.3-3.9,25.9-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.3,245.9s-3,6.1-2.2,7.4,2.2,1.8,2.2,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.3,319.3s-16.9-48.1-20.6-58.1-41.6-56.5-51.4-64.2c-2.7-2.1-29.5-36.5-30.5-42.8-2-13.7-13.3-56.8-7.2-65.2,7.8-10.7,60-22.6,64.6-23.8,1.3-.4,39.4,12.6,47.5,24.6,9.7,14.2,42.4,35.7,49.1,46,10.5,16.3,18.7,38.3,18,41.7-2.9,13.6-45.1,73.9-48.7,83.6s-20.6,58.1-20.6,58.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.3,352.6v-31.5s-31-35.4-48.6-57.4-63.1-33.1-64.7-41.9c-1.8-9.9,5.1-31.3.1-39.1,0,0-28.8-35.4-27.9-44.8.9-9.3,0-44.3,1.8-48.1,3-6.4,18.9-28.6,22.1-31.2,4.6-3.6,36.6-22.1,43-21.4,7.7.8,54.6,2.9,62.6,11.5,14.2,15.3,79.2,67.6,93.4,91.8,12.8,21.9,28,56.1,24.6,64.3s-40.1,36.8-57.8,58.8c-17.6,22-48.6,57.4-48.6,57.4v31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M62.1,229.8c-19.8,11.7-52.2,98-60.6,108.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.3,217.8s-14.6,0-25.2-20.8c0,0-13.2,8.6-14.5,9.5,0,0,8.7,31.7,15.6,37.1,0,0,14.5-25.6,24.1-25.8Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownquestion5);
export default __webpack_public_path__ + "static/media/unknown question5.ab777534bd5be4fbbcc548b646ef649f.svg";
export { ForwardRef as ReactComponent };